import { ExampleList } from "./ExampleList";
import { NavContent } from "./NavContent";

const BASE_PATH = "/examples";

export const examples = ({ getConfig }) => {
  const exampleUrl = getConfig("examples.chuckNorris.url");

  return [
    {
      target: "$ONE_LAYOUT_NAV_CONTENT",
      handler: {
        component: NavContent,
        props: {
          basePath: BASE_PATH
        }
      }
    },
    {
      target: "$ONE_LAYOUT_ROUTE",
      handler: {
        exact: true,
        path: BASE_PATH,
        element: <ExampleList basePath={BASE_PATH} exampleUrl={exampleUrl} />
      }
    }
  ];
};
